// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.guide-page {
  background: var(--bg-primary);
}

.guide-container {
  max-width: 76rem;
  margin: 0 auto;
  padding: 1.75rem 1.5rem 4rem;
}

.guide-header {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 0.9rem;
  margin: 1.1rem 0 2rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid var(--border-primary);
}

.guide-title {
  margin: 0;
}

/* Spalten: Inhaltsverzeichnis links (Desktop), Text rechts */
.guide-shell {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
}

.guide-aside {
  display: none;
}

.guide-main {
  min-width: 0;
  max-width: 50rem;
}

.guide-title-row {
  display: flex;
  align-items: center;
  gap: 1.1rem;
}

.guide-title-icon {
  width: 4rem;
  height: 4rem;
  --frame-tick: 11px;
}

/* Inhaltsverzeichnis */
.guide-toc {
  position: sticky;
  top: calc(var(--header-height) + 1.5rem);
  display: grid;
  gap: 0.6rem;
}

.guide-toc .ui-eyebrow {
  margin: 0;
}

.guide-toc ol {
  margin: 0;
  padding: 0;
  list-style: none;
  border-left: 1px solid var(--border-primary);
}

.guide-toc a {
  position: relative;
  display: block;
  padding: 0.35rem 0 0.35rem 0.9rem;
  font-size: 0.92rem;
  line-height: 1.35;
  color: var(--text-secondary);
}

.guide-toc a:hover {
  color: var(--text-primary);
}

.guide-toc a.active {
  color: var(--text-primary);
  font-weight: 700;
}

.guide-toc a.active::before {
  content: '';
  position: absolute;
  left: -1px;
  top: 0.3rem;
  bottom: 0.3rem;
  width: 3px;
  background: var(--accent-primary);
}

/* Mobil/Tablet: Sprungmarken als Chips unter der Einleitung */
.guide-toc-inline {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  margin-top: 0.25rem;
}

.guide-toc-inline a {
  padding: 0.3rem 0.6rem;
  border: 1px solid var(--border-primary);
  font-size: 0.86rem;
  color: var(--text-primary);
}

.guide-toc-inline a:hover {
  border-color: var(--accent-primary);
  color: var(--accent-primary);
}

@media (min-width: 1080px) {
  .guide-shell {
    grid-template-columns: 14rem minmax(0, 1fr);
    gap: 3.5rem;
  }

  .guide-aside {
    display: block;
    padding-top: 1.4rem;
  }

  .guide-toc-inline {
    display: none;
  }
}

.guide-lead p {
  margin: 0;
  font-size: 1.08rem;
  color: var(--text-secondary);
}

.guide-lead p + p {
  margin-top: 0.75rem;
}

.guide-scope {
  margin: 0;
  color: var(--text-secondary);
  font-size: 0.95rem;
}

.guide-content {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 0;
}

/* Abschnitte: Linien statt Karten */
.guide-section {
  padding: 2rem 0 0.5rem;
  scroll-margin-top: calc(var(--header-height) + 60px);
}

.guide-section + .guide-section {
  border-top: 1px solid var(--border-primary);
}

.guide-section-head {
  display: grid;
  gap: 0.3rem;
  margin-bottom: 1rem;
}

.guide-section-head h2 {
  margin: 0;
}

.guide-section h3 {
  margin: 1.6rem 0 0.6rem;
}

.guide-section p {
  color: var(--text-primary);
  margin: 0 0 0.9rem;
}

.guide-section ul:not(.steps):not(.breadcrumbs),
.guide-section ol:not(.steps) {
  margin: 0 0 1rem;
  padding-left: 1.25rem;
  color: var(--text-primary);
}

.guide-section li + li {
  margin-top: 0.35rem;
}

/* Beispiel-/Codeblock */
.guide-example {
  display: block;
  margin: 0.4rem 0 1rem;
  padding: 0.75rem 1rem;
  border: 1px solid var(--border-primary);
  background: var(--bg-secondary);
  font-family: var(--font-mono);
  font-size: 0.92rem;
  color: var(--text-primary);
  overflow-x: auto;
  white-space: pre;
}

/* Abbildung in Anleitungen */
.guide-figure {
  margin: 1rem 0 1.5rem;
}

.guide-figure img {
  display: block;
  max-width: 100%;
  height: auto;
  border: 1px solid var(--border-primary);
}

.guide-figure figcaption {
  margin-top: 0.5rem;
  font-size: 0.88rem;
  color: var(--text-tertiary);
}

@media (max-width: 680px) {
  .guide-container {
    padding: 1.25rem 1rem 3rem;
  }

  .guide-title-icon {
    width: 3rem;
    height: 3rem;
  }

  .guide-title-icon .guide-icon {
    width: 26px;
    height: 26px;
  }
}

.guide-section h4 {
  margin: 1.25rem 0 0.5rem;
}

/* Text links, Bild rechts (Desktop) */
.guide-split {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 1rem 2rem;
  align-items: start;
}

@media (min-width: 820px) {
  .guide-split {
    grid-template-columns: minmax(0, 1fr) minmax(0, 15rem);
  }
}

.guide-figure-watch img {
  width: 100%;
  max-width: 17rem;
  border: 0;
  background: transparent;
}

.guide-figure-wide img {
  width: 100%;
}

/* ---------- Anbieterwahl (Wetter) ---------- */
.provider-picker {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(100%, 9.5rem), 1fr));
  gap: 0.6rem;
  margin: 0.25rem 0 1.5rem;
}

.provider-option {
  display: grid;
  align-content: start;
  gap: 0.5rem;
  min-height: 6.5rem;
  padding: 0.85rem 0.85rem 0.9rem;
  color: var(--text-primary);
  text-align: left;
  --frame-color: var(--border-secondary);
}

.provider-option:hover {
  border-color: var(--accent-primary);
  --frame-color: var(--accent-primary);
}

.provider-option.selected {
  background: var(--accent-soft);
  border-color: var(--accent-primary);
  --frame-color: var(--accent-primary);
}

.provider-option.selected::after {
  background-size: 100% 2px, 2px 100%, 100% 2px, 2px 100%;
}

.provider-name {
  font-family: var(--font-display);
  font-size: 1.3rem;
  font-weight: 700;
  line-height: 1.05;
  text-transform: uppercase;
}

@media (max-width: 680px) {
  .provider-name {
    font-size: 1.08rem;
  }

  .provider-option {
    min-height: 0;
    padding: 0.7rem;
  }
}

.provider-facts {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
}

.provider-fact {
  padding: 0.05rem 0.35rem;
  border: 1px solid var(--accent-primary);
  font-family: var(--font-mono);
  font-size: 0.64rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  line-height: 1.5;
  text-transform: uppercase;
  color: var(--accent-primary);
}

.provider-fact.needs-key {
  border-color: var(--signal);
  color: var(--signal);
}

.provider-panel {
  padding: 1.25rem 1.25rem 0.5rem;
  border-left: 3px solid var(--accent-primary);
  background: var(--bg-secondary);
  --note-ground: var(--bg-secondary);
}

.provider-panel > h3 {
  margin: 0 0 0.75rem;
  font-family: var(--font-display);
  font-size: 1.45rem;
  text-transform: uppercase;
}

.provider-missing {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.4rem 0.75rem;
  margin: 0.25rem 0 1rem;
}

.provider-missing ul {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  margin: 0 !important;
  padding: 0 !important;
  list-style: none;
}

.provider-missing li {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  margin: 0 !important;
  padding: 0.1rem 0.5rem;
  border: 1px solid var(--border-secondary);
  font-size: 0.9rem;
  color: var(--text-secondary);
}

.provider-missing li svg {
  color: var(--signal);
}

/* ---------- Prüfliste mit Icons ---------- */
.checklist-title {
  margin: 1.25rem 0 0.6rem !important;
  font-weight: 700;
}

.guide-section ul.checklist {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 13rem), 1fr));
  gap: 0.75rem;
  margin: 0 0 1rem;
  padding: 0;
  list-style: none;
}

.checklist li {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin: 0 !important;
  font-size: 0.97rem;
}

/* Zwei Bilder nebeneinander (z. B. Ansicht 1 / Ansicht 2) */
.guide-figures {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 15rem));
  gap: 1rem;
}

.guide-split .guide-figures {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.guide-figures .guide-figure {
  margin: 0.5rem 0;
}

@media (min-width: 820px) {
  .guide-split:has(.guide-figures) {
    grid-template-columns: minmax(0, 1fr) minmax(0, 27rem);
  }
}

/* Verweis-Karte auf eine andere Anleitung */
.guide-link-card {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin: 0.5rem 0 1rem;
  padding: 0.9rem 1rem;
  color: var(--text-primary);
}

.guide-link-card > span:nth-child(2) {
  display: grid;
  gap: 0.15rem;
  flex: 1;
  min-width: 0;
}

.guide-link-card strong {
  font-family: var(--font-display);
  font-size: 1.2rem;
  text-transform: uppercase;
}

.guide-link-card > span:nth-child(2) > span {
  font-size: 0.93rem;
  color: var(--text-secondary);
}

.guide-link-card > svg:last-child {
  flex-shrink: 0;
  color: var(--accent-primary);
}

.guide-link-card:hover {
  color: var(--text-primary);
  border-color: var(--accent-primary);
}
`, "",{"version":3,"sources":["webpack://./src/components/GuideLayout/GuideLayout.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,SAAS;AACX;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,wCAAwC;EACxC,aAAa;EACb,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iCAAiC;EACjC,kBAAkB;EAClB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,cAAc;EACd,UAAU;EACV,iCAAiC;AACnC;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,uCAAuC;EACvC,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE;IACE,2CAA2C;IAC3C,WAAW;EACb;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,MAAM;AACR;;AAEA,oCAAoC;AACpC;EACE,sBAAsB;EACtB,oDAAoD;AACtD;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,cAAc;EACd,qBAAqB;EACrB,qBAAqB;EACrB,uCAAuC;EACvC,+BAA+B;EAC/B,6BAA6B;EAC7B,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE;IACE,sDAAsD;EACxD;AACF;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,wEAAwE;EACxE,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,uCAAuC;EACvC,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,4CAA4C;EAC5C,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,sBAAsB;EACtB,yCAAyC;EACzC,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;AACtB;;AAEA,8CAA8C;AAC9C;EACE,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sEAAsE;EACtE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA,4DAA4D;AAC5D;EACE,aAAa;EACb,kDAAkD;EAClD,SAAS;AACX;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,sDAAsD;EACxD;AACF;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,OAAO;EACP,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,mCAAmC;AACrC","sourcesContent":[".guide-page {\n  background: var(--bg-primary);\n}\n\n.guide-container {\n  max-width: 76rem;\n  margin: 0 auto;\n  padding: 1.75rem 1.5rem 4rem;\n}\n\n.guide-header {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 0.9rem;\n  margin: 1.1rem 0 2rem;\n  padding-bottom: 1.5rem;\n  border-bottom: 1px solid var(--border-primary);\n}\n\n.guide-title {\n  margin: 0;\n}\n\n/* Spalten: Inhaltsverzeichnis links (Desktop), Text rechts */\n.guide-shell {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n}\n\n.guide-aside {\n  display: none;\n}\n\n.guide-main {\n  min-width: 0;\n  max-width: 50rem;\n}\n\n.guide-title-row {\n  display: flex;\n  align-items: center;\n  gap: 1.1rem;\n}\n\n.guide-title-icon {\n  width: 4rem;\n  height: 4rem;\n  --frame-tick: 11px;\n}\n\n/* Inhaltsverzeichnis */\n.guide-toc {\n  position: sticky;\n  top: calc(var(--header-height) + 1.5rem);\n  display: grid;\n  gap: 0.6rem;\n}\n\n.guide-toc .ui-eyebrow {\n  margin: 0;\n}\n\n.guide-toc ol {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  border-left: 1px solid var(--border-primary);\n}\n\n.guide-toc a {\n  position: relative;\n  display: block;\n  padding: 0.35rem 0 0.35rem 0.9rem;\n  font-size: 0.92rem;\n  line-height: 1.35;\n  color: var(--text-secondary);\n}\n\n.guide-toc a:hover {\n  color: var(--text-primary);\n}\n\n.guide-toc a.active {\n  color: var(--text-primary);\n  font-weight: 700;\n}\n\n.guide-toc a.active::before {\n  content: '';\n  position: absolute;\n  left: -1px;\n  top: 0.3rem;\n  bottom: 0.3rem;\n  width: 3px;\n  background: var(--accent-primary);\n}\n\n/* Mobil/Tablet: Sprungmarken als Chips unter der Einleitung */\n.guide-toc-inline {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n  margin-top: 0.25rem;\n}\n\n.guide-toc-inline a {\n  padding: 0.3rem 0.6rem;\n  border: 1px solid var(--border-primary);\n  font-size: 0.86rem;\n  color: var(--text-primary);\n}\n\n.guide-toc-inline a:hover {\n  border-color: var(--accent-primary);\n  color: var(--accent-primary);\n}\n\n@media (min-width: 1080px) {\n  .guide-shell {\n    grid-template-columns: 14rem minmax(0, 1fr);\n    gap: 3.5rem;\n  }\n\n  .guide-aside {\n    display: block;\n    padding-top: 1.4rem;\n  }\n\n  .guide-toc-inline {\n    display: none;\n  }\n}\n\n.guide-lead p {\n  margin: 0;\n  font-size: 1.08rem;\n  color: var(--text-secondary);\n}\n\n.guide-lead p + p {\n  margin-top: 0.75rem;\n}\n\n.guide-scope {\n  margin: 0;\n  color: var(--text-secondary);\n  font-size: 0.95rem;\n}\n\n.guide-content {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 0;\n}\n\n/* Abschnitte: Linien statt Karten */\n.guide-section {\n  padding: 2rem 0 0.5rem;\n  scroll-margin-top: calc(var(--header-height) + 60px);\n}\n\n.guide-section + .guide-section {\n  border-top: 1px solid var(--border-primary);\n}\n\n.guide-section-head {\n  display: grid;\n  gap: 0.3rem;\n  margin-bottom: 1rem;\n}\n\n.guide-section-head h2 {\n  margin: 0;\n}\n\n.guide-section h3 {\n  margin: 1.6rem 0 0.6rem;\n}\n\n.guide-section p {\n  color: var(--text-primary);\n  margin: 0 0 0.9rem;\n}\n\n.guide-section ul:not(.steps):not(.breadcrumbs),\n.guide-section ol:not(.steps) {\n  margin: 0 0 1rem;\n  padding-left: 1.25rem;\n  color: var(--text-primary);\n}\n\n.guide-section li + li {\n  margin-top: 0.35rem;\n}\n\n/* Beispiel-/Codeblock */\n.guide-example {\n  display: block;\n  margin: 0.4rem 0 1rem;\n  padding: 0.75rem 1rem;\n  border: 1px solid var(--border-primary);\n  background: var(--bg-secondary);\n  font-family: var(--font-mono);\n  font-size: 0.92rem;\n  color: var(--text-primary);\n  overflow-x: auto;\n  white-space: pre;\n}\n\n/* Abbildung in Anleitungen */\n.guide-figure {\n  margin: 1rem 0 1.5rem;\n}\n\n.guide-figure img {\n  display: block;\n  max-width: 100%;\n  height: auto;\n  border: 1px solid var(--border-primary);\n}\n\n.guide-figure figcaption {\n  margin-top: 0.5rem;\n  font-size: 0.88rem;\n  color: var(--text-tertiary);\n}\n\n@media (max-width: 680px) {\n  .guide-container {\n    padding: 1.25rem 1rem 3rem;\n  }\n\n  .guide-title-icon {\n    width: 3rem;\n    height: 3rem;\n  }\n\n  .guide-title-icon .guide-icon {\n    width: 26px;\n    height: 26px;\n  }\n}\n\n.guide-section h4 {\n  margin: 1.25rem 0 0.5rem;\n}\n\n/* Text links, Bild rechts (Desktop) */\n.guide-split {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 1rem 2rem;\n  align-items: start;\n}\n\n@media (min-width: 820px) {\n  .guide-split {\n    grid-template-columns: minmax(0, 1fr) minmax(0, 15rem);\n  }\n}\n\n.guide-figure-watch img {\n  width: 100%;\n  max-width: 17rem;\n  border: 0;\n  background: transparent;\n}\n\n.guide-figure-wide img {\n  width: 100%;\n}\n\n/* ---------- Anbieterwahl (Wetter) ---------- */\n.provider-picker {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(min(100%, 9.5rem), 1fr));\n  gap: 0.6rem;\n  margin: 0.25rem 0 1.5rem;\n}\n\n.provider-option {\n  display: grid;\n  align-content: start;\n  gap: 0.5rem;\n  min-height: 6.5rem;\n  padding: 0.85rem 0.85rem 0.9rem;\n  color: var(--text-primary);\n  text-align: left;\n  --frame-color: var(--border-secondary);\n}\n\n.provider-option:hover {\n  border-color: var(--accent-primary);\n  --frame-color: var(--accent-primary);\n}\n\n.provider-option.selected {\n  background: var(--accent-soft);\n  border-color: var(--accent-primary);\n  --frame-color: var(--accent-primary);\n}\n\n.provider-option.selected::after {\n  background-size: 100% 2px, 2px 100%, 100% 2px, 2px 100%;\n}\n\n.provider-name {\n  font-family: var(--font-display);\n  font-size: 1.3rem;\n  font-weight: 700;\n  line-height: 1.05;\n  text-transform: uppercase;\n}\n\n@media (max-width: 680px) {\n  .provider-name {\n    font-size: 1.08rem;\n  }\n\n  .provider-option {\n    min-height: 0;\n    padding: 0.7rem;\n  }\n}\n\n.provider-facts {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.25rem;\n}\n\n.provider-fact {\n  padding: 0.05rem 0.35rem;\n  border: 1px solid var(--accent-primary);\n  font-family: var(--font-mono);\n  font-size: 0.64rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  line-height: 1.5;\n  text-transform: uppercase;\n  color: var(--accent-primary);\n}\n\n.provider-fact.needs-key {\n  border-color: var(--signal);\n  color: var(--signal);\n}\n\n.provider-panel {\n  padding: 1.25rem 1.25rem 0.5rem;\n  border-left: 3px solid var(--accent-primary);\n  background: var(--bg-secondary);\n  --note-ground: var(--bg-secondary);\n}\n\n.provider-panel > h3 {\n  margin: 0 0 0.75rem;\n  font-family: var(--font-display);\n  font-size: 1.45rem;\n  text-transform: uppercase;\n}\n\n.provider-missing {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.4rem 0.75rem;\n  margin: 0.25rem 0 1rem;\n}\n\n.provider-missing ul {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n  margin: 0 !important;\n  padding: 0 !important;\n  list-style: none;\n}\n\n.provider-missing li {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  margin: 0 !important;\n  padding: 0.1rem 0.5rem;\n  border: 1px solid var(--border-secondary);\n  font-size: 0.9rem;\n  color: var(--text-secondary);\n}\n\n.provider-missing li svg {\n  color: var(--signal);\n}\n\n/* ---------- Prüfliste mit Icons ---------- */\n.checklist-title {\n  margin: 1.25rem 0 0.6rem !important;\n  font-weight: 700;\n}\n\n.guide-section ul.checklist {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(min(100%, 13rem), 1fr));\n  gap: 0.75rem;\n  margin: 0 0 1rem;\n  padding: 0;\n  list-style: none;\n}\n\n.checklist li {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  margin: 0 !important;\n  font-size: 0.97rem;\n}\n\n/* Zwei Bilder nebeneinander (z. B. Ansicht 1 / Ansicht 2) */\n.guide-figures {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 15rem));\n  gap: 1rem;\n}\n\n.guide-split .guide-figures {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.guide-figures .guide-figure {\n  margin: 0.5rem 0;\n}\n\n@media (min-width: 820px) {\n  .guide-split:has(.guide-figures) {\n    grid-template-columns: minmax(0, 1fr) minmax(0, 27rem);\n  }\n}\n\n/* Verweis-Karte auf eine andere Anleitung */\n.guide-link-card {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin: 0.5rem 0 1rem;\n  padding: 0.9rem 1rem;\n  color: var(--text-primary);\n}\n\n.guide-link-card > span:nth-child(2) {\n  display: grid;\n  gap: 0.15rem;\n  flex: 1;\n  min-width: 0;\n}\n\n.guide-link-card strong {\n  font-family: var(--font-display);\n  font-size: 1.2rem;\n  text-transform: uppercase;\n}\n\n.guide-link-card > span:nth-child(2) > span {\n  font-size: 0.93rem;\n  color: var(--text-secondary);\n}\n\n.guide-link-card > svg:last-child {\n  flex-shrink: 0;\n  color: var(--accent-primary);\n}\n\n.guide-link-card:hover {\n  color: var(--text-primary);\n  border-color: var(--accent-primary);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
